module.exports = __webpack_public_path__ + "img/APP_HEADER_LOGO_contrast.550aff21.png";